import { render, staticRenderFns } from "./DvTextarea.vue?vue&type=template&id=5dbaa8d7&scoped=true&lang=pug"
import script from "./DvTextarea.vue?vue&type=script&lang=js"
export * from "./DvTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbaa8d7",
  null
  
)

export default component.exports